
export const dialogTitleStyles = (theme) => ({
  root: {
    fontSize: '1.5em',
    fontWeight: 'bold',
    fontFamily: theme.typography.fontFamily[0],
    color: theme.palette.text.primary,
  },
});

export const dialogActionStyles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
});

export const dialogContentStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    margin: '0 25px',
  },
  header: {
    color: theme.palette.text.primary,
    fontSize: '2.25em',
    fontWeight: 'bold',
    marginBottom: '25px',
  },
  message: {
    color: theme.palette.text.primary,
    fontSize: '1.25em',
  },
  text: {
    fontSize: '1em',
  },
});

// export const errorIconStyles = (theme) => ({
//   root: {
//     color: theme.palette.common.swatch[600],
//     fontSize: '2em',
//     display: 'inline-block',
//   },
// });
